import React from 'react';
import settings from '../assets/icons/setting.svg';
const Settings = () => {
  return (
    <div id='setting'>
      <div>
        <div>
          <p>PFLEGEHILFESET KONFIGURATOR</p>
          <button className='circle'>
            <img src={settings} alt='' />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
